import {SET_CYCO_FINANCING_OPTION, SET_CYCO_FAILED_VALIDATION} from './CycoPageConstants';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_CYCO_FAILED_VALIDATION:
            return {
                ...state,
                cycoValidationErrors: action.payload
            };
        default:
            return state;
    }
};
